module.exports = __webpack_public_path__ + "img/light-mud-decal-25.3360a2b1.png";